export const CONTACT_INIT_VALUES = {
  name: '',
  company: '',
  email: '',
  phone: '',
};
